<template>
    <div class="meeting-list">
        <div class="list-tittle">
            <div class="tittle-left">
                <span class="list" style="width: 70px">人员管理</span>
                <span @click="addDialog" class="lauch-list">+新增人员</span>
            </div>
						<person-dialog
							:visible.sync="showDialog"
							:showId.sync="showid"
							:showType.sync="showtype"
							:detailInfo="detailInfo"
							@getPersonList="getPersonList">
						</person-dialog>
            <div class="tittle-right">
                <span class="status-select">
                    <span>角色类型</span>
                    <el-select v-model="roleType" placeholder="请选择角色类型" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in roleoption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <span>状态</span>
                    <el-select v-model="searchStatus" placeholder="请选择状态" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in statusoption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <el-input v-model="keyWords" placeholder="搜索机构名称/姓名" clearable style="width: 240px"></el-input>
                </span>
                <span @click="getPersonList()" class="search-list">搜索</span>
            </div>
        </div>
        <div class="content">
            <div class="item_body">
                <el-table :data="personList" cell-class-name = "cell-name" header-cell-class-name = 'cell-name' style="width: 100%">
                    <el-table-column prop="userName" label="姓名" width="160px"></el-table-column>
                    <!-- <el-table-column prop="idCard" label="身份证号"></el-table-column> -->
                    <el-table-column prop="roleName" label="角色"></el-table-column>
										<el-table-column prop="createTime" :formatter="formatDate" label="创建时间"></el-table-column>
										<el-table-column prop="orgName" label="所属机构"></el-table-column>
                    <el-table-column label="状态">
											<template slot-scope="scope">
												<el-switch
													v-model="scope.row.status"
													@change="changeSwitch($event,scope.row,scope.$index)"
													active-value="0"
													inactive-value="1"
													></el-switch>
											</template>
										</el-table-column>
                    <el-table-column min-width ='110' label="操作">
                        <template slot-scope="scope">
                            <el-button  class="btn-action red" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                            <el-button  class="btn-action" @click="handleShow(scope.row)" type="text" size="small">查看</el-button>
                            <el-button  class="btn-action" @click="handleEdit(scope.row)" type="text" size="small">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page-box" v-if= 'totalData'>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalData"
                    :current-page.sync="curIndex"
                    :page-size="pageSize"
                    @current-change="changepage"
                    prev-text="上一页"
                    next-text="下一页">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {
  listBackstageUser,
  deleteBackstageUser,
  updateBackstageUserStatus
} from "@/api/person";
import { ERR_OK } from "@/api/reConfig";
import {
  dateformat,
  setStore,
  getUrlParams,
  getStore,
  removeStore,
  getStoreSession
} from "@/utils/utils.js";
import personDialog from "../../components/personDialog";

export default {
  data() {
    return {
      showid: "",
      showtype: "新增",
      showDialog: false, //新增对话框显示
      curIndex: 1,
      pageSize: 10,
      totalData: 0,
      roleType: "",
      searchStatus: "",
      roleoption: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "MEDIATOR",
          label: "仲裁员"
        },
        {
          value: "CLERK",
          label: "书记员"
        },
        {
          value: "MANAGE",
          label: "管理员"
        }
      ],
      statusoption: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "启用"
        },
        {
          value: "1",
          label: "停用"
        }
      ],
      personList: [], //人员列表
      keyWords: "",
      cancelFlag: false,
      currentLoginUserId: null,
      caseId: null,
			detailInfo:{}
    };
  },
  created() {
    if (getUrlParams().appName) {
      setStore("appName", getUrlParams().appName);
    }
    this.getPersonList();
  },
  components: {
    personDialog
  },
  mounted() {
    this.caseId = getUrlParams().caseId ? getUrlParams().caseId : this.caseId;
    if (getUrlParams().token) {
      setStore("isOutter", 1);
      setStore("flk", getUrlParams().token);
      document.querySelector(".el-header").style.display = "none";
      document.querySelector(".el-aside").style.display = "none";
    }
  },
  methods: {
    getPersonList(page) {
      !page && (this.curIndex = 1);
      let params = {
        status: this.searchStatus ? this.searchStatus : null,
        roleCode: this.roleType ? this.roleType : null,
        pageIndex: this.curIndex,
        pageSize: this.pageSize,
        keyword: this.keyWords ? this.keyWords : null
      };
      listBackstageUser(params).then(res => {
        if (res.data.code === 1000) {
          let data = res.data.data;
          this.personList = data.list;
          this.totalData = data.totalRows;
          this.curIndex = data.pageIndex;
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      });
    },
    formatDate(mtime) {
      if (!mtime.createTime) {
        return;
      }
      let date = new Date(mtime.createTime);
      return dateformat(date, "yyyy-MM-dd hh:mm");
    },
    changepage(value) {
      this.curIndex = value;
      this.getPersonList(1);
    },
    addDialog() {
      this.showDialog = true;
      this.showid = "";
      this.showtype = "新增";
    },
    handleDelete({ userId }) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel",
        confirmButtonClass: "confirm",
        type: "warning"
      })
        .then(async () => {
          let data = await deleteBackstageUser({ userId });
          data.code === 1000 &&
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          this.getPersonList(this.curIndex);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleShow( row ) {
      this.showDialog = true;
			this.detailInfo = row;
			this.showtype = "查看";
    },
    handleEdit(row) {
      this.showDialog = true;
      this.detailInfo = row;
      this.showtype = "编辑";
    },
    // 修改用户当前得状态
    changeSwitch(data, row, index) {
      let statusText = data === "0" ? "启用" : "停用";
      this.$confirm("此操作将" + statusText + "该账户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel",
        confirmButtonClass: "confirm",
        type: "warning"
      })
        .then(() => {
          let st = data === "0" ? "0" : "1";
          let params = {
            userId: row.userId,
            status: st
          };
          updateBackstageUserStatus(params).then(
            res => {
              if (res.data.code === 1000) {
                this.$message({
                  type: "success",
                  message: "状态修改成功"
                });
                this.getPersonList(this.curIndex);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message
                });
              }
            },
            err => {
              let newData = row;
              newData.status = newData.status === "0" ? "1" : "0";
              this.personList[index] = newData;
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
          let newData = row;
          newData.status = newData.status === "0" ? "1" : "0";
          this.personList[index] = newData;
        });
    },
    searchChangepage() {
      this.curIndex = 1;
      this.getPersonList();
    }
  }
};
</script>
<style lang="scss">
.el-message-box__wrapper {
  .el-message-box.book_quit {
    width: 440px;
    text-align: center;
    position: relative;
    .el-message-box__header {
      border-bottom: 1px solid #e5e5e5;
      padding: 20px 35px 10px;
      font-size: 16px;
      color: #666;
      text-align: left;
      padding-left: 40px;
      &:before {
        content: "";
        position: absolute;
        display: inline-block;
        left: 26px;
        top: 18px;
        width: 4px;
        height: 20px;
        background: #0083c8;
      }
    }
    .el-message-box__btns {
      text-align: center;
      .book_button_primary_small {
        color: #fff;
        margin-left: 30px;
      }
      .book_button_default_small {
        background: #fff;
        color: #0083c8;
      }
      .el-button {
        width: 150px;
        height: 50px;
      }
    }
  }
}
.meeting-list {
  .list-tittle {
    width: 100%;
    height: 60px;
    background: #fff;
    overflow: hidden;
    line-height: 60px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .tittle-left {
        flex-shrink: 0;
      .lauch-list {
        cursor: pointer;
        font-size: 14px;
        display: inline-block;
        border-radius: 4px;
        margin-left: 0px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #0083c8;
        color: #0083c8;
        text-align: center;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
      margin-left: 20px;
      font-size: 16px;
      color: #333333;
      .list {
        display: inline-block;
        margin-right: 20px;
      }
      .el-button {
        height: 30px;
        width: 96px;
        line-height: 5px;
        border-radius: 4px;
        border: solid 1px #0083c8;
        color: #0083c8;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
    }
    .tittle-right {
      display: flex;
      margin-right: 20px;
      .status-select {
        display: flex;
        margin-left: 20px;
        span {
          font-size: 15px;
          color: #606266;
          margin-right: 10px;
        }
      }
      .search-list {
        cursor: pointer;
        font-size: 14px;
        display: inline-block;
        border-radius: 4px;
        margin-left: 20px;
        width: 80px;
        height: 30px;
        margin-top: 14px;
        line-height: 30px;
        border: 1px solid #0083c8;
        color: #0083c8;
        text-align: center;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
    }
  }
  .item_body {
    margin-top: 10px;
    .cell-name {
      text-align: center;
    }
    .btn-action {
      font-size: 14px;
    }
    .red {
      color: #ff0000;
    }
  }
  .page-box {
    background: #fff;
    text-align: center;
    padding: 40px 0 40px;
    li {
      padding: 0;
      border: none;
    }
  }
}
.cancel {
  border-radius: 0px;
}
.confirm {
  border-radius: 0px;
}
</style>
